    import { Button } from "../../../components/ui/button";
    
    export const columns = [
        { key: "fullName", label: "Full Name" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "qualification", label: "Qualification" },
        { key: "specialization", label: "Specialization" },
        { key: "opd_timing", label: "OPD Timing" },
        { key: "consultation_fee", label: "Consultation Fee" },
        {
            key: "edit",
            label: "Edit",
            render: () => (
                <Button className="bg-yellow-400 hover:bg-yellow-500 text-black h-8 px-4">
                    Edit
                </Button>
            ),
        },
    ];



    export const data = [
        {
            fullName: "Dr. Amit Kumar",
            email: "amit@hospital.com",
            phone: "9876543210",
            qualification: "MBBS, MD",
            specialization: "Cardiology",
            opd_timing: "Mon, Wed, Fri",
            consultation_fee: "₹500",
        },
         {
            fullName: "Dr. Amit Kumar",
            email: "amit@hospital.com",
            phone: "9876543210",
            qualification: "MBBS, MD",
            specialization: "Cardiology",
            opd_timing: "Mon, Wed, Fri",
            consultation_fee: "₹500",
        }
    ];
